import styled from 'styled-components';

import { QuizBlockRoot } from './quizBlock.styles';

export const SummaryRoot = styled(QuizBlockRoot)`
  .summary-card {
    overflow: hidden;
  }

  .summary-hero {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 18px 18px 0;
    background: linear-gradient(
      180deg,
      rgba(79, 70, 229, 0.06) 0%,
      rgba(79, 70, 229, 0) 100%
    );
  }

  .summary-hero img {
    display: block;
    max-width: 100%;
    max-height: 220px;
    object-fit: contain;
  }

  .summary-body {
    padding: 18px;
  }

  .summary-meter-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 26px;
    font-size: 15px;
    font-weight: 700;
  }

  .summary-badge {
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(79, 70, 229, 0.1);
    color: var(--quiz-accent, var(--quiz-accent-fallback));
    font-size: 12.5px;
    font-weight: 600;
  }

  .summary-meter {
    position: relative;
    margin-bottom: 8px;
  }

  .summary-meter-track {
    height: 10px;
    border-radius: 999px;
    background: linear-gradient(90deg, #ef4444 0%, #f59e0b 50%, #22c55e 100%);
  }

  .summary-marker {
    position: absolute;
    top: 50%;
    width: 22px;
    height: 22px;
    border: 4px solid #ffffff;
    border-radius: 50%;
    background: var(--quiz-accent, var(--quiz-accent-fallback));
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.25);
    transform: translate(-50%, -50%);
    transition: left 0.8s cubic-bezier(0.22, 1, 0.36, 1);
  }

  .summary-marker-label {
    position: absolute;
    bottom: calc(100% + 6px);
    left: 50%;
    padding: 2px 8px;
    border-radius: 6px;
    background: #111827;
    color: #ffffff;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    transform: translateX(-50%);
  }

  .summary-meter-scale {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 18px;
    font-size: 12.5px;
    opacity: 0.7;
  }

  .summary-insight {
    margin-bottom: 18px;
    padding: 14px 16px;
    border-left: 3px solid var(--quiz-accent, var(--quiz-accent-fallback));
    border-radius: 10px;
    background: rgba(79, 70, 229, 0.06);
  }

  .summary-insight-title {
    margin: 0 0 6px;
    font-size: 15px;
    font-weight: 700;
  }

  .summary-insight-text {
    margin: 0;
    font-size: 14px;
    line-height: 1.55;
  }

  .summary-details {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .summary-detail {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .summary-detail-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: rgba(15, 23, 42, 0.05);
    font-size: 20px;
  }

  .summary-detail-label {
    display: block;
    font-size: 12.5px;
    opacity: 0.65;
  }

  .summary-detail-text {
    display: block;
    font-size: 15px;
    font-weight: 600;
  }
`;
